/** Shared hash routes and page ids for the data-flow workspace (Data perspective). */

export const DATA_FLOW_SUB_PAGE_PARENTS = {
  "data-flow-connection-detail": "data-flow-connections",
  "data-flow-connection-edit": "data-flow-connections",
  "data-flow-connection-create": "data-flow-connections",
  "data-flow-dataset-detail": "data-flow-datasets",
  "data-flow-dataset-register": "data-flow-datasets",
  "data-flow-detail": "data-flows",
  "data-run-detail": "data-runs",
};

export const DATA_FLOW_HASH_PAGE_ROUTES = [
  ["#/admin/data-flow-connection-detail/", "data-flow-connection-detail"],
  ["#/admin/data-flow-connection-edit/", "data-flow-connection-edit"],
  ["#/admin/data-flow-dataset-detail/", "data-flow-dataset-detail"],
  ["#/admin/data-flow-detail/", "data-flow-detail"],
  ["#/admin/data-run-detail/", "data-run-detail"],
];

export const DATA_FLOW_PAGE_IDS = new Set([
  "data-overview",
  "data-flow-connections",
  "data-flow-connection-detail",
  "data-flow-connection-edit",
  "data-flow-connection-create",
  "data-flow-datasets",
  "data-flow-dataset-detail",
  "data-flow-dataset-register",
  "data-flows",
  "data-flow-detail",
  "data-flow-new",
  "data-runs",
  "data-run-detail",
  "data-image-media",
  "data-image-media-casamapa",
  "data-image-media-activity",
  "data-image-media-customers",
  "data-image-media-billing",
  "data-image-media-api",
]);

export const LEGACY_ADMIN_DATA_PATH_TO_PAGE = {
  "data-ops/overview": "data-overview",
  "data-ops/flow-connections": "data-flow-connections",
  "data-ops/flow-datasets": "data-flow-datasets",
  "data-ops/flows": "data-flows",
  "data-ops/runs": "data-runs",
  "data-ops/flow-new": "data-flow-new",
};

export function isDataFlowPageId(pageId) {
  return Boolean(pageId && DATA_FLOW_PAGE_IDS.has(pageId));
}

export function readDataFlowPageFromHash(hash = "") {
  const normalized = hash || (typeof window !== "undefined" ? window.location.hash : "");

  for (const [prefix, pageId] of DATA_FLOW_HASH_PAGE_ROUTES) {
    if (normalized.startsWith(prefix)) {
      return pageId;
    }
  }

  if (normalized === "#/admin/data-flow-connection-create") {
    return "data-flow-connection-create";
  }
  if (normalized === "#/admin/data-flow-dataset-register") {
    return "data-flow-dataset-register";
  }

  return null;
}
